import { configureStore } from "@reduxjs/toolkit";
import scheduleReducer from "./schedule/scheduleSlice";
import uiReducer from "./ui/ui";
import appointmentReduser from "./appointments/appointmentsSlice";
import patientsReduser from "./patients/patients";
import usersReduser from "./users/users";
import dataReduser from "./data/dataSlice";
import serviceReduser from "./service/service";
import staticticReduser from "./statistic/statistic";

export const store = configureStore({
    reducer: {
        schedule: scheduleReducer,
        appointments: appointmentReduser,
        patients: patientsReduser,
        users: usersReduser,
        ui: uiReducer,
        data: dataReduser,
        services: serviceReduser,
        statictic: staticticReduser,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
